import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {StorageService} from '../../services/storage/storage.service';
import {SystemService} from "../../services/system/system.service";
import {AlertMessageType} from "../../model/interface/system-alerts";
import {AuthService} from "../../services/auth/auth.service";
import {CommonRoutes} from "../../model/enum/routes.enum";


@Injectable({
  providedIn: 'root'
})
export class AutorizationGuard implements CanActivate {
  constructor(
    private storageService: StorageService,
    private router: Router,
    private systemService: SystemService,
    private authService: AuthService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const systemAlert = this.systemService.getSystemAlert();

    if (systemAlert && systemAlert.messageType === AlertMessageType.blocker) {
      this.router.navigate(['system-error']).then();
    } else if (!this.storageService.getToken()) {
      this.router.navigate([CommonRoutes.Auth, CommonRoutes.Authorization]);
      return false;
    }
    return true;
  }

}
